/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Qc_Manual_Fix_TooltipInputs */



/**
* | output |
* | --- |
* | "This issue must be corrected manually" |
*
* @param {Qc_Manual_Fix_TooltipInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const qc_manual_fix_tooltip = /** @type {((inputs?: Qc_Manual_Fix_TooltipInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Qc_Manual_Fix_TooltipInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ce problème doit être corrigé manuellement")
	if (locale === "de") return /** @type {LocalizedString} */ ("Dieses Problem muss manuell behoben werden")
	if (locale === "it") return /** @type {LocalizedString} */ ("Questo problema deve essere corretto manualmente")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Эту проблему необходимо исправить вручную")
	if (locale === "es") return /** @type {LocalizedString} */ ("Este problema debe corregirse manualmente")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("此问题需要手动修复")
	if (locale === "ja") return /** @type {LocalizedString} */ ("この問題は手動で修正する必要があります")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इस समस्या को मैन्युअल रूप से ठीक करना होगा")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Este problema tem de ser corrigido manualmente")
	return /** @type {LocalizedString} */ ("This issue must be corrected manually")
});